import { render } from "./FieldLoader.vue?vue&type=template&id=79e5002a&scoped=true"
import script from "./FieldLoader.vue?vue&type=script&lang=js"
export * from "./FieldLoader.vue?vue&type=script&lang=js"

import "./FieldLoader.vue?vue&type=style&index=0&id=79e5002a&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e5002a"]])

export default __exports__